// Converted EditableTable functional component (core structure only):
import React, { useState, useEffect, useMemo } from "react";
import Tablestyles from "../ROCITable.module.css";
import "./rgmretailerview.scss";
import TableContainer from "@material-ui/core/TableContainer";
import { config } from "../../../config/config";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { exportToExcel } from "../../../utils/exportToExcel";
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  withStyles,
} from "@material-ui/core";
import classNames from "classnames";
import TablePagination from "@material-ui/core/TablePagination";
import SearchBar from "../../../components/Searchbar/searchbar";
import CustomSelect from "../../../components/input/select";
import MultiFilter from "../../../components/Dialog/MultiFilter";
import Loader from "../../../components/Loader/Loader";
import ColumnFilter from "../../../components/Dialog/ColumnFilter";
import Tooltip from "@mui/material/Tooltip";
import { hasDangerousCode } from "../../../utils/utils";
import * as XLSX from "@lokalise/xlsx";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#e5e5e5",
    color: "#212529",
    height: 3,
    width: "auto", // let content decide
    minWidth: "30px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  body: {
    fontSize: 12,
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    width: "auto", // let content decide
    minWidth: "30px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  root: {
    padding: "15px",
  },
}))(TableCell);

let api = config.api.api_url;

const Input = ({ name, value, classes, tableName, ...props }) => {
  const [hasError, setError] = useState(false);
  const handleOnChange = (e) => {
    props.onChange(e);
  };

  return (
    <>
      <div
        className={classNames(
          classes.inputWrapperDiv,
          `inputWrapperDiv${tableName}`,
        )}
      >
        <textarea
          className={classNames(classes.input, `input${tableName}`)}
          style={{
            width: "100%",
            backgroundColor: "#fff",
          }}
          rows={2}
          name={name}
          value={value || ""}
          onChange={handleOnChange}
        />
      </div>
    </>
  );
};

const EditableRow = ({
  keys,
  fieldsArr = [],
  editData = {},
  allRowsData,
  customStyles,
  tableName,
  updateSourceInputs,
  sourceData,
  wholeRowData,
  brand_data,
  classes = {},
  editingIndex,
  isEditing,
  selectClasses,
  handleDeleteRow,
  inputClasses,
  updateAlert,
  ...props
}) => {
  const [errorMessage, setErrorMessage] = useState();
  const [rowData, setRowData] = useState(editData);
  const [actualData, setActualData] = useState();
  const [updatedData, setUpdatedRowData] = useState();
  const [dropdownOptions, setDropdownOptions] = useState({});

  const Edit_Column_Module = fieldsArr;
  const DROPDOWN_DATA = sourceData?.data?.dropdown || {};

  // CURRENTLY NOT USING THIS
  const handleDropdownOptions = (key, value, itemName) => {
    const table_header_column_list =
      sourceData.data.dropdown.table_header_column_list;

    // STEP 1 = CHECKS ALL VALUES IN ROWDATA ARE NULL
    let Is_All_Value_In_Row_Null = Edit_Column_Module.every((item) => {
      const options = DROPDOWN_DATA[item.name] || [];
      if (options.length === 0) return true;
      return key && value && itemName
        ? item.name === itemName
          ? value === null
          : rowData[item.name] === null
        : rowData[item.name] === null;
    });

    // STEP 2 = CONDITION CHECK BASED ON STEP 1
    // IF SCOPE EXECUTES ONLY IF Is_All_Value_In_Row_Null === TRUE
    // Is_All_Value_In_Row_Null === TRUE Means then it is a NewRowData
    if (Is_All_Value_In_Row_Null) {
      // ASSIGNS THE DROPDOWN OPTIONS ONLY FOR FIRST COLUMN OF THE EDITABLE COLUMNS
      // FOR REST OF THE COLUMNS IT ASSIGNS EMPTY ARRAY
      Edit_Column_Module.map((item, i) => {
        if (i === 0) {
          setDropdownOptions((prev) => ({
            ...prev,
            [item.name]: DROPDOWN_DATA[item.name],
          }));
        } else {
          setDropdownOptions((prev) => ({
            ...prev,
            [item.name]: [],
          }));
        }
      });
    } else {
      // LOOP OVER ALL THE EDITABLE COLUMNS AND ASSIGN RESPECTIVE DROPDOWN OPTIONS
      table_header_column_list.map((item) => {
        // EXECUTES IF SCOPE IF is_dependent IS TRUE
        // EXECUTES ELSE SCOPE IF is_dependent IS FALSE
        if (item.is_dependent) {
          const FilteredDropdownOptions = DROPDOWN_DATA[item.name]; //DROPDOWN OPTIONS OF PARTICULAR COLUMN
          const Parent_Column_Name = item.parent_column; // DEPENDENCY COLUMN NAME
          const Parent_Column_Value =
            key && value && itemName
              ? Parent_Column_Name === itemName
                ? value
                : rowData[Parent_Column_Name]
              : rowData[Parent_Column_Name]; //ROWDATA VALUE OF THE DEPENDENCY COLUMN NAME

          // FILTERS CORRECT DROPDOWN OPTIONS BASED ON THE DEPENDENCY COLUMN VALUE
          const filteredFinalOptions =
            Parent_Column_Value !== null
              ? FilteredDropdownOptions.filter(
                  (option) =>
                    option[Parent_Column_Name] === Parent_Column_Value,
                )
              : [];

          let FinalOptions;
          // CHECKS IF FILTERED DROPDOWN HAS DEPENDENCY BASED STRUCTURE
          // IF YES = IT FILTERS CORRECT OPTIONS BASED ON THE DEPENDENCY
          // IF NO THEN IT RETURN ENTIRE ARRAY
          Edit_Column_Module.map((editItem) => {
            if (editItem.name === item.name && editItem.isArray) {
              FinalOptions =
                filteredFinalOptions.length > 0
                  ? filteredFinalOptions[0][item.name]
                  : [];
            }

            if (editItem.name === item.name && !editItem.isArray) {
              if (sourceData.current_source === "Pos") {
                FinalOptions =
                  filteredFinalOptions.length > 0
                    ? filteredFinalOptions[0][item.name][
                        rowData[editItem.parent_for_dropdown]
                      ]
                    : [];
              } else {
                const Header_Table_Values =
                  sourceData.current_filter_value === "Create new"
                    ? DROPDOWN_DATA[item.name][
                        editData[editItem.parent_for_dropdown].toUpperCase()
                      ]["HEADER_TABLE"][sourceData.current_country]
                    : DROPDOWN_DATA[item.name][
                        editData[editItem.parent_for_dropdown].toUpperCase()
                      ]["HEADER_TABLE"][sourceData.current_country][
                        sourceData.current_ssfFileId
                      ];
                FinalOptions = [
                  ...Header_Table_Values,
                  ...DROPDOWN_DATA[item.name][
                    editData[editItem.parent_for_dropdown].toUpperCase()
                  ]["BRONZE_TABLE"],
                ];
              }
            }
          });

          // SETS STATE WITH DROPDOWN OPTIONS FOR THE RESPECTIVE COLUMNS
          setDropdownOptions((prev) => ({
            ...prev,
            [item.name]: FinalOptions,
          }));
        } else {
          // CHECKS IF COLUMN IN THE CURRENT ITERATION HAS DROPDOWN FIELD
          let Final_DropDown_Values;
          let result = Edit_Column_Module.find(
            (data) => data.type === "select" && item.name === data.name,
          );

          // IF YES THEN CHECKS IF THE COLUMNS DROPDOWN HAS DEPENDENCY BASED STRUCTURE
          // IF YES = IT FILTERS CORRECT OPTIONS BASED ON THE DEPENDENCY
          // IF NO THEN IT RETURN ENTIRE ARRAY
          if (result && result.type === "select") {
            Edit_Column_Module.map((editItem) => {
              if (editItem.name === item.name && editItem.isArray) {
                Final_DropDown_Values = DROPDOWN_DATA[item.name];
              }
            });
          }

          // SETS STATE WITH DROPDOWN OPTIONS FOR THE RESPECTIVE COLUMNS
          setDropdownOptions((prev) => ({
            ...prev,
            [item.name]: Final_DropDown_Values,
          }));
        }
      });
    }
  };

  // CURRENTLY NOT USING THIS
  useEffect(() => {
    handleDropdownOptions();
  }, []);

  // CURRENTLY NOT USING THIS
  function mergeWithObj2Priority(obj1, obj2) {
    const commonKeys = Object.keys(obj1).filter((key) => key in obj2);

    if (commonKeys.length > 0) {
      // Merge and overwrite obj1 values with obj2 values for common keys
      return {
        ...obj1,
        ...obj2, // obj2 values take priority
      };
    } else {
      // No common keys – just merge all keys
      return {
        ...obj1,
        ...obj2,
      };
    }
  }

  // CURRENTLY NOT USING THIS
  const handleOnSelectChange = (key, val, itemName) => {
    const updatedData = Object.assign({}, rowData, {
      [key]: val,
    });

    setActualData((prev) => ({
      ...prev,
      [key]: rowData[key],
    }));

    setUpdatedRowData((prev) => ({
      ...prev,
      [key]: val,
    }));
    setRowData(updatedData);
    handleDropdownOptions(key, val, itemName);
  };

  const handleSave = () => {
    const is_Value_Not_Changed = Edit_Column_Module.filter(
      (item) => item.isEditable,
    ).every((item) => rowData[item.name] === editData[item.name]);

    if (!is_Value_Not_Changed) {
      const banner = rowData["BANNER"];
      const isProperValue =
        banner &&
        typeof banner === "string" &&
        banner.toLowerCase() !== "null" &&
        banner.toLowerCase() !== "unmapped";
      const updatedData = {
        ...rowData,
        BANNER: banner?.toUpperCase() || banner,
        BANNER_STATUS: isProperValue ? "MAPPED" : "UNMAPPED",
      };
      props.handleSave(updatedData, wholeRowData.item_Id);
    } else {
      updateAlert({
        open: true,
        message: "No Value has been changed",
        severity: "error",
        closeFlag: true,
      });
    }
  };

  const handleOnInputChange = (e, itemName) => {
    const ColumnValue = e?.target?.value || "";
    const ALLOWED_SPECIAL_CHARACTERS =
      DROPDOWN_DATA?.allowed_special_characters || "";
    const hasExplicitDanger = hasDangerousCode(
      ColumnValue,
      ALLOWED_SPECIAL_CHARACTERS,
    );

    if (hasExplicitDanger && !hasExplicitDanger?.isValid) {
      updateAlert({
        open: true,
        message: `${hasExplicitDanger?.error}`,
        severity: "error",
        closeFlag: true,
      });
      return false;
    }

    if (e.target.value === "") {
      const updatedData = Object.assign({}, rowData, {
        [itemName]: editData[itemName],
      });
      setRowData(updatedData);
      return;
    }

    const updatedData = Object.assign({}, rowData, {
      [itemName]: e.target.value,
    });

    setRowData(updatedData);
  };

  const handleCancel = () => {
    props.handleCancel(wholeRowData.item_Id);
  };

  return (
    <TableRow
      key={`editable-${keys}`}
      className={classNames(classes.tableBodyRow, `tableBodyRow_${tableName}`)}
    >
      {/* Content */}
      {Edit_Column_Module.map((item, i) => {
        return (
          <StyledTableCell
            className={classNames(
              classes.tableBodyCell,
              `tableBodyCell_${tableName}`,
            )}
            key={i}
          >
            <div
              className="scrollable-cell"
              style={{
                width: "150px", // fixed width
                overflowX: "auto", // scroll if content overflows
                whiteSpace: "nowrap", // prevent wrapping
                display: "block", // required for scroll to work inside table cell
              }}
            >
              {item.type === "select" ? (
                item.isEditable ? (
                  <CustomSelect
                    errorMessage={errorMessage}
                    classes={{
                      ...selectClasses,
                    }}
                    tableName={tableName}
                    name={item.name}
                    onChange={(key, val) => {
                      handleOnSelectChange(key, val, item.name);
                    }}
                    options={dropdownOptions[item.name] || []}
                    customStyles={customStyles}
                    value={rowData[item.name]}
                    error={item.error}
                    selectMessage={item.selectMessage}
                    validation={item.validation}
                    readonly={
                      (dropdownOptions[item.name] || []).length === 0 ||
                      (item.isValidation &&
                        rowData[item.validation] === null) ||
                      rowData[item.validation] === ""
                        ? true
                        : false ||
                          (item.isEditable === false &&
                            wholeRowData.isNewData === false)
                    }
                    showLabel={false}
                  />
                ) : wholeRowData.isNewData ? (
                  <CustomSelect
                    errorMessage={errorMessage}
                    classes={{
                      ...selectClasses,
                    }}
                    tableName={tableName}
                    name={item.name}
                    onChange={(key, val) => {
                      handleOnSelectChange(key, val, item.name);
                    }}
                    options={dropdownOptions[item.name] || []}
                    customStyles={customStyles}
                    value={rowData[item.name]}
                    error={item.error}
                    selectMessage={item.selectMessage}
                    validation={item.validation}
                    readonly={
                      (dropdownOptions[item.name] || []).length === 0 ||
                      (item.isValidation &&
                        rowData[item.validation] === null) ||
                      rowData[item.validation] === ""
                        ? true
                        : false ||
                          (item.isEditable === false &&
                            wholeRowData.isNewData === false)
                    }
                    showLabel={false}
                  />
                ) : (
                  <div>{rowData[item.name]}</div>
                )
              ) : item.type === "input" ? (
                <>
                  <Input
                    tableName={tableName}
                    classes={{ ...inputClasses }}
                    type={item.type}
                    name={item.name}
                    onChange={(e) => {
                      handleOnInputChange(e, item.name);
                    }}
                    value={
                      item.name === "BANNER" &&
                      ((rowData[item.name] &&
                        rowData[item.name].toLowerCase() === "unmapped") ||
                        rowData[item.name]?.toLowerCase() === "not assigned")
                        ? ""
                        : rowData[item.name] || ""
                    }
                    item={item.name}
                  />
                  {!wholeRowData.isValidated && wholeRowData.errorMessage && (
                    <p className="error-message">{wholeRowData.errorMessage}</p>
                  )}
                </>
              ) : (
                <div>
                  {String(rowData[item.name])?.length > 0
                    ? String(rowData[item.name])?.length > 30
                      ? `${String(rowData[item.name]).slice(0, 30)}...`
                      : String(rowData[item.name])
                    : ""}
                </div>
              )}
            </div>
          </StyledTableCell>
        );
      })}

      {/* Actions */}
      <StyledTableCell
        className={classNames(
          classes.tableBodyCell,
          `tableBodyCell_${tableName}`,
        )}
      >
        {
          <i
            className="material-icons-outlined "
            style={{ color: "red" }}
            onClick={handleCancel}
          >
            cancel
          </i>
        }
        {
          <i
            className="material-icons-outlined "
            style={{ color: "green" }}
            onClick={handleSave}
          >
            done
          </i>
        }
      </StyledTableCell>
    </TableRow>
  );
};

const Row = ({
  keys,
  rowData,
  headingRow,
  handleEditRow,
  handleDeleteRow,
  updateSourceInputs,
  classes,
  tableName,
  isAdding,
  isEditing,
  sourceData,
  allRowsData,
  isAllRowsInPageChecked,
  rowChecked,

  updateSourceHandler,
}) => {
  let data = rowData.rowData;

  const handleEditingRow = () => {
    handleEditRow(rowData.item_Id);
  };

  const handleRowDelete = () => {
    const MODIFIED_MAPPED_DATA = sourceData.modified_mapped_data;
    const Updated_Modified_data = MODIFIED_MAPPED_DATA.filter((item) => {
      const updated = item.updated;
      const isEditedRowData = Object.keys(data).every((key) => {
        return updated[key] === data[key];
      });

      return !isEditedRowData && item;
    });

    updateSourceInputs("modified_mapped_data", Updated_Modified_data);
    handleDeleteRow(rowData.item_Id);
  };

  const handleEachCheckBox = (item_Id) => {
    const TABLE_DATA = allRowsData.map((data) => {
      if (data.item_Id === item_Id) {
        return {
          ...data,
          isCheckedRow: !data.isCheckedRow,
        };
      }
      return data;
    });
    const rowCheckedCount = TABLE_DATA.filter((item) => item.isCheckedRow);
    updateSourceHandler(TABLE_DATA, rowCheckedCount.length);
  };

  return (
    <TableRow
      key={`Rowkey-${keys}`}
      className={`${rowData.isValidated ? "table-row" : "table-row-two"}`}
    >
      {headingRow.map(({ label, name }, indexs) =>
        name !== "actions" ? (
          <>
            <StyledTableCell
              key={`key-${indexs}`}
              className={classNames(
                classes.tableBodyCell,
                `tableBodyCell_${tableName}`,
              )}
            >
              {/* <Tooltip
                title={
                  name === "BANNER" ? (
                    <>
                      {String(data[name])?.length > 0 &&
                      data[name] !== null &&
                      data[name] !== "null"
                        ? String(data[name]).toUpperCase()
                        : "UNMAPPED"}
                    </>
                  ) : (
                    <>
                      {String(data[name])?.length > 0 ? String(data[name]) : ""}
                    </>
                  )
                }
                placement="bottom-start"
                PopperProps={{
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [-5, -10], // x, y offset from the element
                      },
                    },
                  ],
                }}
              > */}

              {indexs === 0 ? (
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <input
                    type="checkbox"
                    style={{ height: "14px", width: "14px" }}
                    onChange={(e) => {
                      handleEachCheckBox(rowData.item_Id);
                    }}
                    checked={rowChecked}
                  />
                  <div
                    className="scrollable-cell cell-wrapper"
                    style={{
                      width: "150px", // fixed width
                      overflowX: "auto", // scroll if content overflows
                      whiteSpace: "nowrap", // prevent wrapping
                      display: "block", // required for scroll to work inside table cell
                    }}
                  >
                    {name === "BANNER" ? (
                      <>
                        {String(data[name])?.length > 0 &&
                        data[name] !== null &&
                        data[name] !== "null"
                          ? String(data[name]).toUpperCase()
                          : "UNMAPPED"}
                      </>
                    ) : (
                      <>
                        {String(data[name])?.length > 0
                          ? String(data[name])
                          : ""}
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  className="scrollable-cell cell-wrapper"
                  style={{
                    width: "100%", // fixed width
                    // height:"40px",
                    padding: "0px 3px",
                    border:
                      data[name]?.length > 40 ? "1px solid #cecece" : "none",
                    overflowY: "auto", // scroll if content overflows
                    whiteSpace: "nowrap", // prevent wrapping
                    display: "block", // required for scroll to work inside table cell
                    textWrap: "wrap",
                  }}
                >
                  {name === "BANNER" ? (
                    <>
                      {String(data[name])?.length > 0 &&
                      data[name] !== null &&
                      data[name] !== "null"
                        ? String(data[name]).toUpperCase()
                        : "UNMAPPED"}
                    </>
                  ) : (
                    <>
                      {String(data[name])?.length > 0 ? String(data[name]) : ""}
                    </>
                  )}
                </div>
              )}
              {/* </Tooltip> */}
            </StyledTableCell>
          </>
        ) : (
          // Actions buttons
          <StyledTableCell
            className={classNames(
              classes.tableBodyCell,
              `tableBodyCell_${tableName}`,
            )}
          >
            <div className="action-icon-container">
              <span>
                {!sourceData.any_row_isEditing ? (
                  <>
                    <i
                      className="material-icons-outlined "
                      disabled={isAdding || isEditing}
                      onClick={handleEditingRow}
                    >
                      edit
                    </i>
                  </>
                ) : (
                  <>
                    <i className="material-icons-outlined ">edit</i>
                  </>
                )}
              </span>
              {rowData.isNewData && (
                <span>
                  <i
                    className="material-icons-outlined"
                    disabled={rowData.isNewData}
                    style={{ color: "red" }}
                    onClick={handleRowDelete}
                  >
                    delete
                  </i>
                </span>
              )}
            </div>
          </StyledTableCell>
        ),
      )}
    </TableRow>
  );
};

const EditableTable = (props) => {
  const { classes = {}, tableName, ...rest } = props;
  const [allRowsData, setAllRowsData] = useState(props.defaultData || []);
  const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage || 5);
  const [page, setPage] = useState(props.page || 0);
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [paginatedRows, setPaginatedRows] = useState(
    allRowsData.slice(0, rowsPerPage),
  );
  const [isAllRowsInPageChecked, setIsAllRowsInPageChecked] = useState(false);
  const [checkedRowCount, setCheckedRowCount] = useState(
    props.checkedRowCount || 0,
  );

  //   Multi Filter States
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState(
    props.source_data.appliedFilters || [],
  );
  const [filteredRows, setFilteredRows] = useState();
  const [tableHeadColumns, setTableHeadColumns] = useState([
    ...(
      props.source_data?.data?.dropdown?.table_header_column_list ?? []
    ).filter(
      (item) =>
        !props?.source_data?.data?.dropdown?.unwanted_table_column.includes(
          item.name,
        ),
    ),
    { label: "Actions", name: "actions" },
  ]);

  const [selectedColumns, setSelectedColumns] = useState(() => {
    const editColumns =
      props?.source_data?.data?.dropdown?.edit_model_column_list || [];

    return tableHeadColumns
      .map((item) => editColumns.find((col) => col.name === item.name))
      .filter(Boolean);
  });

  const handlePaginatedRows = (newPage, AllRowsData) => {
    const start = newPage * rowsPerPage;
    const end = start + rowsPerPage;
    const currentPageRows = AllRowsData
      ? AllRowsData.slice(start, end)
      : allRowsData.slice(start, end);
    return currentPageRows;
  };

  const handleSave = (updatedRowData, editingIndex) => {
    props.setGlobalEdit(true);
    const updated = props.source_data.current_mapped_data.map((item) =>
      item.item_Id === editingIndex
        ? { ...item, isEditing: false, rowData: updatedRowData }
        : item,
    );

    let Updated_Modified_Data;
    if (
      props.source_data.modified_mapped_data &&
      props.source_data.modified_mapped_data.length > 0
    ) {
      let found = false;
      Updated_Modified_Data = props.source_data.modified_mapped_data.map(
        (item) => {
          if (item.item_Id === editingIndex) {
            found = true;
            return { ...item, rowData: updatedRowData };
          }
          return item;
        },
      );
      if (!found) {
        Updated_Modified_Data.push({
          item_Id: editingIndex,
          rowData: updatedRowData,
        });
      }
    } else {
      Updated_Modified_Data = [
        { item_Id: editingIndex, rowData: updatedRowData },
      ];
    }
    props.updateSourceInputs("current_mapped_data", updated);
    props.updateSourceInputs("modified_mapped_data", Updated_Modified_Data);
    props.updateSourceInputs("any_row_isEditing", false);
    props.updateSourceInputs("isNewDataInserted", false);

    const Paginated_Rows = handlePaginatedRows(page, updated);
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(updated);
    setEditingIndex(null);
    setIsEditing(false);
  };

  const handleCancel = (index) => {
    const updated = props.source_data.current_mapped_data.map((item) =>
      item.item_Id === index ? { ...item, isEditing: false } : item,
    );
    const updated_Filtered_Rows = props.source_data.filtered_Rows.map((item) =>
      item.item_Id === index ? { ...item, isEditing: false } : item,
    );
    props.updateSourceInputs("current_mapped_data", updated);
    props.updateSourceInputs("filtered_Rows", updated_Filtered_Rows);
    props.updateSourceInputs("any_row_isEditing", false);

    const Paginated_Rows = handlePaginatedRows(page, updated);
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(updated);
    setEditingIndex(null);
    setIsEditing(false);
  };

  const handleEditRow = (index) => {
    const updated = props.source_data.current_mapped_data.map((item) =>
      item.item_Id === index ? { ...item, isEditing: true } : item,
    );
    const updated_Filtered_Rows = props.source_data.filtered_Rows.map((item) =>
      item.item_Id === index ? { ...item, isEditing: true } : item,
    );
    props.updateSourceInputs("current_mapped_data", updated);
    props.updateSourceInputs("filtered_Rows", updated_Filtered_Rows);
    props.updateSourceInputs("any_row_isEditing", true);

    setAllRowsData(updated);
    const Paginated_Rows = handlePaginatedRows(page, updated);
    setPaginatedRows(Paginated_Rows);
    setEditingIndex(index);
    setIsEditing(true);
  };

  const handleDeleteRow = (index) => {
    const updated = props.source_data.current_mapped_data.filter(
      (item) => item.item_Id !== index,
    );
    const reindexed = updated.map((item, idx) => ({ ...item, item_Id: idx }));
    props.updateSourceInputs("current_mapped_data", reindexed);
    props.updateSourceInputs("any_row_isEditing", false);
    props.updateSourceInputs("isNewDataInserted", false);

    const Paginated_Rows = handlePaginatedRows(page, reindexed);
    setPaginatedRows(Paginated_Rows);
    props.updateAlert({
      open: true,
      message: "RowData has been Deleted successfully",
      severity: "info",
      closeFlag: true,
    });
  };

  const handleSearchValue = (val) => {
    setPage(0);
    setRowsPerPage(10);
    if (!val || val.length === 0) {
      setAllRowsData(props.source_data.current_mapped_data);
      setSearchValue("");
      props.updateSourceInputs("searchValue", "");

      if (
        props.source_data.appliedFilters &&
        props.source_data.appliedFilters.length > 0
      ) {
        handleApplyFilter(
          appliedFilters.Column,
          appliedFilters.Values,
          0,
          props.source_data.appliedFilters,
        );
      } else {
        const Paginated_Rows = handlePaginatedRows(
          0,
          props.source_data.current_mapped_data,
        );
        setPaginatedRows(Paginated_Rows);
      }
    } else {
      let filtered;
      if (
        props.source_data.filtered_Rows &&
        props.source_data.filtered_Rows.length > 0
      ) {
        filtered = props.source_data.filtered_Rows.filter((item) => {
          return props.source_data.data.dropdown.search_filter_details.search_filter_attributes.some(
            (attribute) => {
              return (item?.rowData[attribute.name] || "")
                .toLowerCase()
                .includes(val.toLowerCase());
            },
          );
        });
      } else {
        filtered = props.source_data.current_mapped_data.filter((item) => {
          return props.source_data.data.dropdown.search_filter_details.search_filter_attributes.some(
            (attribute) => {
              return (item?.rowData[attribute.name] || "")
                .toLowerCase()
                .includes(val.toLowerCase());
            },
          );
        });
      }
      setSearchValue(val);
      props.updateSourceInputs("searchValue", val);
      setAllRowsData(filtered);
      const Paginated_Rows = handlePaginatedRows(0, filtered);
      setPaginatedRows(Paginated_Rows);
    }
  };

  const handleCheckboxAll = () => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const updated = allRowsData.map((item, i) => {
      if (i >= startIndex && i < endIndex) {
        return {
          ...item,
          isCheckedRow: !isAllRowsInPageChecked,
        };
      }
      return item;
    });

    const count = updated.filter((item) => item.isCheckedRow).length;

    setAllRowsData(updated);
    setCheckedRowCount(count);
    setIsAllRowsInPageChecked(!isAllRowsInPageChecked);
    props.updateSourceHandler(updated, count);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const Paginated_Rows = handlePaginatedRows(newPage);
    setPaginatedRows(Paginated_Rows);

    const startIndex = newPage * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const AllRowsChecked = allRowsData
      .slice(startIndex, endIndex)
      .every((item, i) => {
        return item.isCheckedRow === true;
      });

    setIsAllRowsInPageChecked(AllRowsChecked);
  };

  const handleChangeRowsPerPage = (e) => {
    const value = parseInt(e.target.value);
    setRowsPerPage(value);
    const start = 0 * value;
    const end = start + value;
    const currentPageRows = allRowsData.slice(start, end);
    setPaginatedRows(currentPageRows);
    setPage(0);
  };

  const handleDownload = () => {
    if (isEditing) {
      props.updateAlert({
        open: true,
        message:
          "Cannot download while editing. Please try after editing the record.",
        severity: "info",
        closeFlag: true,
      });
      return;
    }

    // FILE NAME GENERATION
    const fileName = `${props.source_data.current_bussines_unit}_${
      props.source_data.current_country_code
    }_${new Date().toLocaleDateString("en-GB").replace(/\//g, "")}`;

    // META DATA FOR EXCEL FILE
    const headerMeta = [
      ["", fileName],
      [],
      [
        "",
        "",
        "Business Unit",
        props.source_data.current_bussines_unit,
        "",
        "",
        "Country",
        props.source_data.current_country,
      ],
      [],
    ];

    // INITIALIZING TABLE DATA
    const tableData = props.source_data.current_mapped_data.map((item) => {
      return props.sourceDropdownData.edit_model_column_list.reduce(
        (acc, col) => {
          acc[col.label] = item.rowData[col.name] || null;
          return acc;
        },
        {},
      );
    });
    exportToExcel(headerMeta, tableData, fileName);
  };

  const handleDownloadNew = () => {
    if (isEditing) {
      props.updateAlert({
        open: true,
        message:
          "Cannot download while editing. Please try after editing the record.",
        severity: "info",
        closeFlag: true,
      });
      return;
    }

    // INITIALIZING TABLE DATA
    const MetaData_Filter =
      props?.source_data?.data?.dropdown?.metadata_filter || [];
    const tableData =
      props?.source_data?.current_mapped_data.map((item) => ({
        ...item.rowData,
      })) || [];

    if (!tableData || !tableData.length > 0) {
      props.updateAlert({
        open: true,
        message: "No sample data available to download.",
        severity: "Failed",
        closeFlag: true,
      });
      return;
    }

    let order_check_data = [
      ...(MetaData_Filter || []),
      ...(props?.source_data?.data?.dropdown?.table_header_column_list.map(
        (item) => item.name,
      ) || []),
    ];

    if (props.source_data?.current_source?.toLowerCase() === "nielsen") {
      order_check_data = [
        ...order_check_data.filter((item) => item !== "COUNTRY_CODE"),
        "COUNTRY_CODE",
      ];
    }

    const Download_Data = tableData.map((item) => {
      const { CREATED_AT, CREATED_BY, UPDATED_AT, UPDATED_BY, ...rest } = item;
      // filter arrayTwo keeping order of arrayOne
      let result = {};
      order_check_data.forEach((key) => {
        result = {
          ...result,
          [key]: rest[key] || "",
        };
      });
      return result;
    });

    const sampleData = [...Download_Data];
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data");
    XLSX.writeFile(
      workbook,
      `${Download_Data?.[0]?.[MetaData_Filter?.[1]] || "Table Data"}_${
        props?.source_data?.current_source || ""
      }.xlsx`,
    );
  };

  const handleApplyFilter = (column, values, currentPage, filters) => {
    // STORES AND UPDATE FILTERS
    const newFilters =
      typeof currentPage === "number"
        ? filters
          ? [...filters]
          : [...appliedFilters]
        : [...appliedFilters, { Column: column, Values: values }];
    setAppliedFilters(newFilters);
    props.updateSourceInputs("appliedFilters", newFilters);

    const ALL_ROWS = props.source_data.current_mapped_data || [];

    // CHECK ROWS THAT MATCHES THE FILTERS
    let filtered;
    if (newFilters.length > 0) {
      const FILTERED_ROWS = props.source_data.filtered_Rows;
      const CURRENT_FILTER = [{ Column: column, Values: values }];
      if (FILTERED_ROWS && FILTERED_ROWS.length > 0) {
        if (filters && filters.length > 0) {
          let FILTERED_ROWS = ALL_ROWS;
          filters.forEach((filter) => {
            FILTERED_ROWS = FILTERED_ROWS.filter((row) => {
              const cellValue = row?.rowData?.[filter.Column.name];
              return filter.Values.includes(cellValue);
            });
          });
          filtered = FILTERED_ROWS;
        } else {
          filtered = FILTERED_ROWS.filter((row) =>
            CURRENT_FILTER.some((filter) =>
              filter.Values.includes(row.rowData[filter.Column.name]),
            ),
          );
        }
      } else {
        filtered = ALL_ROWS.filter((row) =>
          CURRENT_FILTER.some((filter) =>
            filter.Values.includes(row.rowData[filter.Column.name]),
          ),
        );
      }
    } else {
      filtered = ALL_ROWS;
    }

    // UPDATES THE FILTERED ROWS
    setFilteredRows(filtered);
    props.updateSourceInputs("filtered_Rows", filtered);

    // UPDATES THE FILTERED ROWS WITH CURRENT PAGINATION
    const Paginated_Rows = handlePaginatedRows(
      typeof currentPage === "number" ? currentPage : 0,
      filtered,
    );
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(filtered);
  };

  const handleRemoveFilter = (filter) => {
    // REMOVES FILTER FROM FILTER LIST
    const SortedFilters = appliedFilters.filter((existingFilter) => {
      const isSame_Column = existingFilter.Column.label === filter.Column.label;

      const valuesA = existingFilter.Values;
      const valuesB = filter.Values;

      const isSame_Values =
        valuesA.length === valuesB.length &&
        valuesA.every((val) => valuesB.includes(val));

      const result = isSame_Column && isSame_Values ? false : true;

      return result;
    });

    setAppliedFilters(SortedFilters);
    props.updateSourceInputs("appliedFilters", SortedFilters);

    const ALL_ROWS = props.source_data.current_mapped_data || [];

    // CHECK ROWS THAT MATCHES THE FILTERS
    let FILTERED_ROWS;
    if (SortedFilters.length > 0) {
      SortedFilters.forEach((filter) => {
        FILTERED_ROWS = ALL_ROWS.filter((row) => {
          const cellValue = row?.rowData?.[filter.Column.name];
          return filter.Values.includes(cellValue);
        });
      });
    } else {
      FILTERED_ROWS = ALL_ROWS;
    }

    // UPDATES THE FILTERED ROWS
    setFilteredRows(FILTERED_ROWS);
    props.updateSourceInputs("filtered_Rows", FILTERED_ROWS);

    // UPDATES THE FILTERED ROWS WITH CURRENT PAGINATION
    const Paginated_Rows = handlePaginatedRows(0, FILTERED_ROWS);
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(FILTERED_ROWS);
  };

  const moveBannerToLast = (arr) => {
    const bannerItem = arr.find((item) => item.name === "BANNER");
    const TradeTypeItem = arr.find((item) => item.name === "TRADE_TYPE_DESC");
    if (!bannerItem) return arr;

    // Filter out the banner and push it to the end
    const filtered = arr.filter(
      (item) => item.name !== "BANNER" && item.name !== "TRADE_TYPE_DESC",
    );
    return [...filtered, TradeTypeItem, bannerItem];
  };

  const handleColumnFilter = (columns) => {
    if (!Array.isArray(columns)) {
      props.updateAlert({
        open: true,
        message: "invalid columns selection",
        severity: "Failed",
        closeFlag: true,
      });
      return;
    }

    const editModelColumns =
      props?.source_data?.data?.dropdown?.edit_model_column_list || [];

    // SORT TABLE HEADER COLUMNS
    const Sorted_Table_Head_Columns = [
      ...moveBannerToLast([...columns]),
      { label: "Actions", name: "actions" },
    ];

    // SORT EDITABLE COLUMNS
    const Sorted_Columns = moveBannerToLast(
      Sorted_Table_Head_Columns.map((item) =>
        editModelColumns.find((col) => col.name === item.name),
      ).filter(Boolean),
    );

    // SET STATES
    setTableHeadColumns(Sorted_Table_Head_Columns);
    setSelectedColumns(Sorted_Columns);
    props.updateSourceInputs("current_columns", Sorted_Table_Head_Columns);
  };

  const handleColumnChange = () => {
    const editModelColumns =
      props?.source_data?.data?.dropdown?.edit_model_column_list || [];
    const currentColumns = props?.source_data?.current_columns || [];

    if (!Array.isArray(editModelColumns) || !Array.isArray(currentColumns)) {
      return;
    }

    if (editModelColumns.length === 0 || currentColumns.length === 0) {
      return;
    }

    // SORT EDITABLE COLUMNS
    const Sorted_Columns = [
      ...editModelColumns.filter((item) =>
        currentColumns.some((col) => col.name === item.name),
      ),
    ];

    // SORT TABLE HEADER COLUMNS
    const Sorted_Table_Head_Columns = [...currentColumns];

    // SET STATES
    setTableHeadColumns(Sorted_Table_Head_Columns);
    setSelectedColumns(Sorted_Columns);
  };

  const handleOpenColumnFilter = (e) => {
    if (isEditing) {
      props.updateAlert({
        open: true,
        message:
          "Cannot Filter columns while editing. Please try after editing the record.",
        severity: "info",
        closeFlag: true,
      });
      return;
    }
    setAnchorE2(e.currentTarget);
  };

  const handleNullCheck = () => {
    const dropdown = props.source_data?.data?.dropdown;
    const currentMappedData = props.source_data?.current_mapped_data;

    return (
      dropdown?.table_header_column_list?.length === 0 &&
      dropdown?.duplicate_validation_attributes?.length === 0 &&
      dropdown?.edit_model_column_list?.length === 0 &&
      Array.isArray(currentMappedData) &&
      currentMappedData.length === 0
    );
  };

  const headerList =
    props.source_data?.data?.dropdown?.table_header_column_list || [];

  useEffect(() => {
    handleColumnChange();
  }, [props.source_data.current_columns]);

  useEffect(() => {
    setAllRowsData(props.defaultData || []);
    let Paginated_Rows;
    if (props.source_data.isNewDataInserted) {
      Paginated_Rows = handlePaginatedRows(0, props.defaultData);
      setPage(0);
      setRowsPerPage(10);
    } else {
      Paginated_Rows = handlePaginatedRows(page, props.defaultData);
    }

    setPaginatedRows(Paginated_Rows);
  }, [props.defaultData]);

  // Apply Filters
  useEffect(() => {
    // Reapply all filters
    if (
      props.source_data.appliedFilters &&
      props.source_data.appliedFilters.length > 0
    ) {
      handleApplyFilter(
        appliedFilters.Column,
        appliedFilters.Values,
        page,
        props.source_data.appliedFilters,
      );
    }

    if (
      props.source_data.searchValue &&
      props.source_data.searchValue.length > 0
    ) {
      handleSearchValue(props.source_data.searchValue);
    }
  }, [props.source_data.current_mapped_data]);

  // Apply Search Filter
  useEffect(() => {
    // Apply search
    const searchValue = props.source_data.searchValue;
    const hasSearchValue =
      typeof searchValue === "string" && searchValue.length > 0;
    const hasFilteredRows =
      Array.isArray(props.source_data.filtered_Rows) &&
      props.source_data.filtered_Rows.length > 0;

    if (hasSearchValue && hasFilteredRows) {
      const Filtered_Rows = props.source_data.filtered_Rows;
      const filtered = Filtered_Rows.filter((item) => {
        const name = (item?.rowData?.CUST_NAME || "").toLowerCase();
        const banner = (item?.rowData?.BANNER || "").toLowerCase();
        return (
          name.includes(searchValue.toLowerCase()) ||
          banner.includes(searchValue.toLowerCase())
        );
      });

      const Paginated_Rows = handlePaginatedRows(page, filtered);
      setPaginatedRows(Paginated_Rows);
      setAllRowsData(filtered);
    }
  }, [props.source_data.filtered_Rows]);

  useEffect(() => {
    if (
      props.source_data.appliedFilters.length === 0 &&
      appliedFilters.length > 0
    ) {
      setAppliedFilters([]);
    }
  }, [props.source_data.appliedFilters]);

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const AllRowsChecked = props.source_data.current_mapped_data
      .slice(startIndex, endIndex)
      .every((item, i) => {
        return item.isCheckedRow === true;
      });

    setIsAllRowsInPageChecked(AllRowsChecked);
  }, [props.source_data.checked_rows_count]);

  if (handleNullCheck()) {
    return <Loader />;
  }

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        {/* SEARCH FILTER */}
        {props?.source_data?.data?.dropdown?.search_filter_details
          ?.is_search_filter && (
          <SearchBar
            handleSearchValue={handleSearchValue}
            placeholder={`Search with ${
              (
                props?.source_data?.data?.dropdown?.search_filter_details
                  ?.search_filter_attributes || []
              )
                .map((attr) => attr?.label)
                .filter(Boolean)
                .join(", ") || "..."
            }`}
            value={props?.source_data?.searchValue || ""}
          />
        )}

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {/* MULTI FILTER */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {/* Filter Pill */}
            <div className="scroll-bar">
              {appliedFilters.map((filter) => {
                return (
                  <div className="pill">
                    <span
                      style={{
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {filter.Column.label}
                    </span>
                    <span
                      style={{
                        margin: "0 6px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      is one of
                    </span>
                    <span
                      style={{
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100px",
                      }}
                    >
                      {filter.Values.map((v) =>
                        v === null
                          ? "Null"
                          : v === undefined
                            ? "Undefined"
                            : String(v),
                      ).join(", ")}
                    </span>
                    <button
                      onClick={() => handleRemoveFilter(filter)}
                      style={{
                        marginLeft: "8px",
                        color: "#666",
                        fontSize: "18px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#e00")}
                      onMouseLeave={(e) => (e.target.style.color = "#666")}
                    >
                      &times;
                    </button>
                  </div>
                );
              })}
            </div>

            {/* Filter Button */}
            <div>
              {props?.source_data?.data?.dropdown &&
                props?.source_data?.data?.dropdown?.filter_details
                  ?.is_filterable && (
                  <button
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    className="filter-button"
                  >
                    <span
                      className="material-symbols-outlined"
                      style={{
                        fontVariationSettings: "'wght' 200",
                        fontSize: "20px",
                      }}
                    >
                      {props?.source_data?.data?.dropdown?.filter_details
                        ?.button_icon || "filter_alt"}
                    </span>
                    <span>
                      {props?.source_data?.data?.dropdown?.filter_details
                        ?.button_text || "Filter"}
                    </span>
                  </button>
                )}
            </div>

            {/* Filter POPOVER */}
            {props?.source_data?.data?.dropdown?.filter_details && (
              <MultiFilter
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                columns={
                  props.source_data.data.dropdown.filter_details.filter_details
                }
                values={
                  filteredRows && filteredRows.length > 0
                    ? filteredRows
                    : props.source_data.current_mapped_data || []
                }
                onApplyFilter={handleApplyFilter}
              />
            )}
          </div>

          {/* COLUMN FILTER */}
          {props?.source_data?.data?.dropdown?.column_filter_details &&
            props?.source_data?.data?.dropdown?.column_filter_details
              ?.is_column_filterable && (
              <div>
                {/* BUTTON */}
                <button
                  onClick={handleOpenColumnFilter}
                  className="filter-button"
                >
                  <span
                    className="material-symbols-outlined"
                    style={{
                      fontVariationSettings: "'wght' 200",
                      fontSize: "20px",
                    }}
                  >
                    {props?.source_data?.data?.dropdown?.column_filter_details
                      ?.button_icon || "table_edit"}
                  </span>
                  <span>
                    {props?.source_data?.data?.dropdown?.column_filter_details
                      ?.button_text || "Columns"}
                  </span>
                </button>

                {/* POPOVER */}
                <ColumnFilter
                  anchorE2={anchorE2}
                  setAnchorE2={setAnchorE2}
                  totalColumns={
                    props?.source_data?.data?.dropdown?.column_filter_details
                      ?.filterable_columns || []
                  }
                  tableHeaderColumns={tableHeadColumns.filter(
                    (col) => col.name !== "actions",
                  )}
                  standardHeaderColumns={
                    props?.source_data?.data?.dropdown?.table_header_column_list
                  }
                  onApplyFilter={handleColumnFilter}
                  updateAlert={props.updateAlert}
                  sourceData={props?.source_data}
                  useCase={"RGMRetailerMapping"}
                />
              </div>
            )}

          {/* DOWNLOAD BUTTON */}
          {props?.source_data?.data?.dropdown?.downloable_details &&
            props?.source_data?.data?.dropdown?.downloable_details
              ?.is_downloadble && (
              <button onClick={handleDownload} className="filter-button">
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontVariationSettings: "'wght' 200",
                    fontSize: "20px",
                  }}
                >
                  {props?.source_data?.data?.dropdown?.downloable_details
                    ?.button_icon || ""}{" "}
                </span>
                <span>
                  {props?.source_data?.data?.dropdown?.downloable_details
                    ?.button_text || "Download"}
                </span>
              </button>
            )}

          {/* PowerBI Button */}
          {props?.source_data?.data?.dropdown?.POWER_BI_DETAILS &&
            props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
              ?.IS_POWER_BI && (
              <a
                href={
                  props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
                    ?.POWER_BI_URL || "#"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="powerbi-button"
              >
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontVariationSettings: "'wght' 200",
                    fontSize: "20px",
                  }}
                >
                  {props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
                    ?.button_icon || ""}
                </span>
                <span>
                  {props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
                    ?.button_text || "PowerBI Dashboard"}
                </span>
              </a>
            )}
        </div>
      </div>

      <TableContainer className={Tablestyles.budget_tb2}>
        <Table
          stickyHeader
          className={classNames(classes.table, `table_${tableName}`)}
        >
          <TableHead className="table-heading">
            <TableRow
              className={classNames(
                classes.tableHeadRow,
                `tableHeadRow_${tableName}`,
              )}
            >
              {tableHeadColumns.map(({ label, name }, i) => (
                <StyledTableCell
                  key={i}
                  className={classNames(
                    classes.tableHeadCell,
                    classes[`tableHeadCell${name}`],
                    `tableHeadCell_${tableName} tableHeadCell_${name}`,
                  )}
                >
                  {i === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginLeft: "3px",
                        maxWidth: "100%",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <input
                        type="checkbox"
                        style={{ height: "14px", width: "14px" }}
                        onChange={handleCheckboxAll}
                        checked={isAllRowsInPageChecked}
                      />
                      <span>{label}</span>
                    </div>
                  ) : (
                    <div
                      style={{
                        maxWidth: "100%",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {label}
                    </div>
                  )}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody
            className={classNames(classes.tableBody, `tableBody_${tableName}`)}
          >
            {paginatedRows.map((rowData, i) =>
              rowData.isEditing ? (
                <EditableRow
                  key={i}
                  updateAlert={props.updateAlert}
                  tableName={tableName}
                  isEditing={rowData.isEditing}
                  customStyles={{}}
                  wholeRowData={rowData}
                  editingIndex={editingIndex}
                  handleDeleteRow={handleDeleteRow}
                  brand_data={props.brand_data}
                  updateSourceInputs={props.updateSourceInputs}
                  sourceData={props.source_data}
                  selectClasses={classes}
                  inputClasses={classes}
                  classes={classes}
                  allRowsData={allRowsData}
                  editData={rowData.rowData}
                  handleSave={handleSave}
                  handleCancel={handleCancel}
                  fieldsArr={selectedColumns}
                />
              ) : (
                <Row
                  key={i}
                  tableName={tableName}
                  classes={classes}
                  updateSourceInputs={props.updateSourceInputs}
                  sourceData={props.source_data}
                  headingRow={tableHeadColumns}
                  isAdding={isAdding}
                  isEditing={isEditing}
                  handleEditRow={handleEditRow}
                  handleDeleteRow={handleDeleteRow}
                  handleCheckboxAll={handleCheckboxAll}
                  isAllRowsInPageChecked={isAllRowsInPageChecked}
                  rowData={rowData}
                  allRowsData={allRowsData}
                  rowChecked={rowData.isCheckedRow}
                  updateSourceHandler={props.updateSourceHandler}
                />
              ),
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <div style={{ marginTop: "5px" }}>
        {allRowsData.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={allRowsData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </div>
      {allRowsData.length === 0 && (
        <div style={{ textAlign: "center" }}>No Data Found.</div>
      )}
    </>
  );
};

EditableTable.propTypes = {
  brand_data: PropTypes.object,
  updateAlert: PropTypes.func,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  source_data: state.source,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

// export default EditableTable;
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditableTable),
);
